<template>
  <div class="container">
    <a-drawer
      v-model:visible="open"
      class="container"
      width="350"
      root-class-name="root-class-name"
      :root-style="{ color: 'blue' }"
      :title="`绑定${title}详情`"
      :maskClosable="false"
      :placement="placement"
    >
      <div class="popover-header-box">
        <div class="popover-header z-flex">
          <div class="popover-header-img">
            <div v-if="activeKey === 'patient'" :class="[{ real: data.status === 1 }, 'auth']">
              {{ data.status === 1 ? '已实名' : '未实名' }}
            </div>
            <auth-img :src="data.headUrl || item.cb" />
          </div>
          <div class="popover-header-info z-flex">
            <div class="name z-flex">
              <div>{{ data.username }}</div>
              <auth-img :src="handleImg(data.gender)" v-if="[0, 1].includes(data.gender)" />
            </div>
            <div class="base_info number">
              {{ item.p_title.label }}{{ data[`${item.p_title.key}`] }}
              <span v-if="activeKey === 'patient' && data.age" class="age">
                {{ data.age ? `${data.age}岁` : '' }}
              </span>
            </div>
            <div class="base_info">
              使用权限：
              <span :class="{ permission: [1, 2, 3].includes(data.accountStatus) }">
                {{ ['正常', '停用', '注销', '停用 | 注销'][data.accountStatus] || '--' }}
              </span>
            </div>
            <div class="base_info location" v-if="activeKey === 'patient' && data.address">
              <auth-img :src="location" alt="" />
              {{ data.address }}
            </div>
          </div>
        </div>
        <template v-if="activeKey === 'patient' && !isGuideConsult" @click.stop>
          <RemarkPopover
            v-bind="$attrs"
            mode="patient"
            @updateRemark="() => emit('updateRemark')"
          />
        </template>
        <template v-if="activeKey === 'doctor'" @click.stop>
          <RemarkPopover
            v-bind="$attrs"
            mode="doctor"
            :remarkData="remarkData"
            :initParam="doctorRemarkInitParam"
            @updateRemark="handelUpdateRemark"
            :allowClear="true"
          />
        </template>
      </div>
      <div class="popover-content">
        <div class="health_service z-flex" v-if="activeKey === 'patient'">
          <div @click="healthInfo" class="btn z-flex">
            <auth-img :src="healthIcon" alt="" />
            <span>健康信息</span>
            <auth-img :src="right" alt="" class="right" />
          </div>
          <div @click="goServiceReocrd" class="btn z-flex">
            <auth-img :src="service" alt="" />
            <span>服务记录</span>
            <auth-img :src="right" alt="" class="right" />
          </div>
          <div @click="goTreatSheet" class="btn z-flex">
            <auth-img :src="service" alt="" />
            <span>复诊日程</span>
            <auth-img :src="right" alt="" class="right" />
          </div>
        </div>
        <div class="box_container">
          <div
            class="box z-flex"
            v-for="(it, index) in item.p_content"
            :key="it.label"
            :class="{
              first_box: index === 0,
              last_box: it.key === 'changeAt' && data['changeAt']
            }"
          >
            <div class="title">{{ it.label }}</div>
            <div class="details" :class="{ announcement_update: it.key === 'changeAt' }">
              <span v-if="activeKey === 'doctor' && it.key === 'doctorTitleId'" class="departName">
                {{ handleLabel(data, 'doctorDepartmentName') }}
              </span>
              {{ handleLabel(data, it.key) }}
            </div>
          </div>
        </div>

        <!-- 医生价格展示 -->
        <div class="doctor_price_info" v-if="activeKey === 'doctor'">
          <div
            class="info_item"
            v-for="infoItem in priceInfoArr"
            :key="infoItem.label"
            :style="infoItem?.itemStyle"
          >
            <div class="price_title">{{ infoItem.label }}</div>
            <div
              v-if="infoItem.key === 'serviceAttribution'"
              class="price_details service_attribution"
              @click="goServiceAttributionDetail"
            >
              <auth-img :src="right" alt="" class="right" />
            </div>
            <div v-else-if="infoItem.key === 'defaultCharge'" class="price_details is_free">
              {{ handleLabel(data, 'defaultCharge') }}
            </div>
            <div v-else-if="infoItem.key === 'thisPatientChargeString'" class="price_details">
              <consultationDetail
                :currentPrice="data[infoItem.key]"
                :ucUserId="data.ucUserId"
                :isRenderOnParentNode="true"
              />
            </div>
            <div
              v-else-if="
                [
                  'doctorDefaultConsultFeeConfigList',
                  'doctorPhoneDefaultConsultFeeConfigList',
                  'doctorVideoDefaultConsultFeeConfigList'
                ].includes(infoItem.key)
              "
              class="price_list"
              :style="infoItem.valueStyle"
            >
              <a-tag v-for="(item, index) in data[infoItem.key]" :key="index" class="price_item">
                {{ detailPrice(item, infoItem.type) }}
              </a-tag>
            </div>
            <div
              v-else-if="infoItem.key === 'firsCureFree'"
              class="price_details"
              :class="{ isOpen: data[infoItem.key] }"
            >
              {{ ['未开启', '已开启'][data[infoItem.key]] }}
            </div>
            <div
              v-else-if="infoItem.key === 'doctorAddCureFree'"
              class="price_details"
              :class="{ isOpen: data[infoItem.key] }"
            >
              {{ ['未开启', '已开启'][data[infoItem.key]] }}
            </div>

            <div v-else class="price_details">--</div>
          </div>
        </div>
        <!-- 添加诊费 -->
        <div
          class="consultationFee"
          v-if="activeKey === 'patient' && curOrder?.consultRecently?.consultRecentlyPrice"
        >
          <div class="content">与该医生最近一次咨询服务</div>
          <div class="price">
            {{ Config.consultTypeEnum[curOrder?.consultRecently?.consultType] }}：{{
              curOrder?.consultRecently?.consultRecentlyPrice
            }}
          </div>
        </div>
        <!-- 绑定医生 -->
        <div class="bind_doc" v-if="activeKey === 'patient'">
          <div class="title z-flex">
            <span>绑定医生</span>
            <span class="more_data" v-if="showMoreBindDoc" @click="goBindDocList">
              查看更多
              <auth-img :src="right" alt="" class="right" />
            </span>
          </div>
          <template v-if="bindDocList.length">
            <div class="doctap" v-for="item in bindDocList" :key="item.ucDoctorId">
              <div class="course_sign" v-if="[0, 1, 2].includes(item.courseServicesFlag)">
                <a-tooltip
                  placement="top"
                  overlayClassName="course_tips"
                  :getPopupContainer="getPopupContainer"
                >
                  <template #title>
                    <span>
                      <span>{{ showPopExcus(item) }}</span>
                    </span>
                  </template>
                  <div
                    class="flag_str"
                    :class="[item.courseServicesFlag ? 'flag_join' : 'flag_ex']"
                  >
                    <span v-if="item.courseServicesFlag === 1">已加入</span>
                    <span v-else-if="item.courseServicesFlag === 0">待加入</span>
                    <span v-else-if="item.courseServicesFlag === 2">未加入</span>
                    <InfoCircleOutlined style="font-size: 10px" />
                  </div>
                </a-tooltip>
              </div>
              <div class="info">
                <span class="name">{{ item.doctorName }}</span>
                <span class="txt depart">{{ item.departmentName }}</span>
                <span class="txt">{{ item.academicTitle }}</span>
              </div>
              <div class="hosp">{{ item.hospitalName }}</div>
              <div class="explain z-flex">
                <span class="source">来源：{{ item.bindSourceDesc }}</span>
                <span class="date">{{ item.bindTime }}</span>
              </div>
            </div>
          </template>
          <!-- 无绑定医生 -->
          <div class="doctap" v-else>
            <a-empty :image="simpleImage" description="暂无绑定医生" />
          </div>
        </div>
        <!-- 医生排班 -->
        <div
          class="doc_schedule_container"
          :class="{ dividingLine: dividingFlag }"
          v-if="activeKey === 'doctor'"
        >
          <docSchedule @helpEditDoc="editDocTime" :bindUcDoctorId="bindUcDoctorId"></docSchedule>
        </div>
        <div class="footer-button">
          <a-button
            class="button"
            v-if="activeKey === 'patient' && !isPatChat && !isGuideConsult"
            @click="
              () => {
                open = false
                emit('talk')
              }
            "
            type="primary"
          >
            发起私聊
          </a-button>
          <a-button
            class="button"
            v-if="
              activeKey === 'doctor' &&
              curOrder.doctorDaGroupId != activeGroupKey &&
              !isHistorySession
            "
            @click="
              () => {
                open = false
                emit('chatWithDoc')
              }
            "
            type="primary"
          >
            发起私聊
          </a-button>
          <template v-if="activeKey !== 'assistant' && !isHistorySession">
            <a-button class="button" block @click="onSendSMS">发送短信</a-button>
            <SendSMS ref="sms"></SendSMS>
          </template>
          <a-button v-if="!isHistorySession" class="button" block @click="call">拨打电话</a-button>
        </div>
      </div>
      <slot name="content"></slot>
    </a-drawer>
    <!-- <serviceRecord
      :serviceRecordVisible="serviceRecordVisible"
      @onClose="serviceRecordVisible = false"
    ></serviceRecord> -->
    <!-- <bindDoc :bindDocVisible="bindDocVisible" @onClose="bindDocVisible = false"></bindDoc> -->
    <AppointSetting ref="appointSetRef" />
    <SetRetreatment ref="treatmentRef" isSheet />
    <!-- 服务归属弹窗 -->
    <ServiceAttributionModal ref="serviceAttributionRef" :data="data" />
  </div>
</template>

<script setup>
import head_p from '@/assets/img/chat/head_p.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png' // BD的默认头像
import male from '@/assets/img/chat/male.png'
import female from '@/assets/img/chat/female.png'
import location from '@/assets/img/chat/location.png'
import healthIcon from '@/assets/img/chat/health.png'
import service from '@/assets/img/chat/service.png'
import right from '@/assets/img/chat/right.png'
import {
  reactive,
  defineProps,
  computed,
  defineEmits,
  ref,
  createVNode,
  defineExpose,
  watch
} from 'vue'
import { useStore } from 'vuex'
import docSchedule from '@/views/WorkPlace/Container/chat/components/rightInfo/components/docSchedule.vue'
import serviceRecord from '@/views/WorkPlace/Container/chat/components/rightInfo/solePopover/serviceRecord.vue'
import AppointSetting from '@/views/WorkPlace/Container/chat/components/rightInfo/components/AppointSetting'
import bindDoc from '@/views/WorkPlace/Container/chat/components/rightInfo/solePopover/bindDoc.vue'
import consultationDetail from '@/views/WorkPlace/Container/chat/components/rightInfo/solePopover/consultationDetail.vue'
import { Empty, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
import { callOut } from '@/utils/Tccc'
import SetRetreatment from '@/views/WorkPlace/Container/chat/components/retreatment/setRetreatment.vue'
import RemarkPopover from '@/components/RemarkPopover'
import SendSMS from '@/components/SendSMS/index'
import { priceInfoArr } from './config'
import moment from 'moment'
import { formatAmount, detailPrice } from '@/utils'
import { getDoctorDetailById, getAssDetailById } from '@/api/workPlace/workOrder'
import { fetchRecommendDoctorDetail } from '@/api/chat'
import ServiceAttributionModal from '@/views/WorkPlace/Container/chat/components/ServiceAttributionModal'
import Config from '@/config/index'
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
const emit = defineEmits(['healthInfo', 'talk', 'updateRemark', 'chatWithDoc'])
const store = useStore()
const isGuideConsult = computed(() => store.state.workOrder.isGuideConsult)
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
// 人员信息协同备注
const remarkData = ref([])
// 医生协同备注初始化参数
const doctorRemarkInitParam = ref({})
const data = ref({})
const activeKey = ref('doctor')
// 绑定医生ucUserId
const bindUcDoctorId = ref(null)
const bindDoctorId = ref(null)
const workOrderGroupInfo = ref({})
const sms = ref()
const appointSetRef = ref()
const serviceRecordVisible = ref(false)
const bindDocVisible = ref(false)
const open = ref(false)
const title = ref('')
const bindInfo = ref({})
const item = computed(() => solesList[activeKey.value])
const dividingFlag = computed(() => {
  const { consultationTimeLastUpdateBy, consultationTimeLastUpdateAt } = data.value
  return consultationTimeLastUpdateBy || consultationTimeLastUpdateAt ? true : false
})
const solesList = reactive({
  patient: {
    cb: head_p, // 默认头像
    p_title: {
      label: '患者ID：',
      key: 'ucUserId',
      type: '患者',
      calleeType: 1
    }
    // p_content: [
    //   {
    //     label: 'BD备注',
    //     key: 'patientRemark'
    //   }
    // ]
  },
  doctor: {
    cb: head_d, // 默认头像
    p_title: {
      label: '医生ID：',
      key: 'businessId',
      type: '医生',
      calleeType: 2
    },
    p_content: [
      {
        label: '所属医院',
        key: 'hospitalName'
      },
      {
        label: '岗位职级',
        key: 'doctorTitleId'
      },
      {
        label: '个人简介',
        key: 'introduction'
      },
      {
        label: '个人公告',
        key: 'notice'
      },
      {
        label: '',
        key: 'changeAt'
      }
    ]
  },
  assistant: {
    cb: head_a, // 默认头像
    p_title: {
      label: 'ERP：',
      key: 'erpId',
      type: 'BD',
      calleeType: 3
    },
    p_content: [
      {
        label: '所属部门',
        key: 'bdDepartmentName'
      }
    ]
  }
})
const props = defineProps({
  placement: {
    type: String,
    required: false,
    default: 'right'
  },
  isPatChat: {
    type: Boolean,
    default: false
  },
  bindDocList: {
    type: Array,
    required: false,
    default: () => [] // 患者绑定的医生
  },
  showMoreBindDoc: {
    type: Boolean,
    default: false
  },
  //关联工单列表
  dealWorkOrderList: {
    type: Array,
    required: false,
    default: () => [] // 患者绑定的医生
  },
  activeGroupKey: {
    // 当前获取的群组id
    type: String,
    default: ''
  },
  isChatSession: {
    type: Boolean,
    default: false
  },
  isHistorySession: {
    type: Boolean,
    default: false
  }
})
const mergeBindInfoData = () => {
  data.value = Object.assign({}, bindInfo.value)
}
watch(
  () => curOrder.value,
  val => {
    workOrderGroupInfo.value = val || {}
  },
  {
    deep: true,
    immediate: true
  }
)
const handleImg = gender => {
  if (gender === 0) {
    return female
  } else if (gender === 1) {
    return male
  } else {
    return ''
  }
}
function onSendSMS() {
  const roleMAP = {
    patient: 1,
    doctor: 2,
    assistant: 3
  }
  const role = roleMAP[activeKey.value]
  const pInfo = {
    id: curOrder.value.patientInfo.ucUserId,
    name: curOrder.value.patientInfo.username
  }
  const dInfo = {
    id: activeKey.value === 'doctor' ? data.value.ucUserId : curOrder.value.doctorInfo.ucUserId,
    name: activeKey.value === 'doctor' ? data.value.username : curOrder.value.doctorInfo.username
  }
  const workId = curOrder.value.targetWorkOrder.workOrderId
  sms.value.open(role, pInfo, dInfo, workId)
  open.value = false
}
const call = () => {
  open.value = false
  Modal.confirm({
    centered: true,
    title: '确定拨打电话',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定给${item.value.p_title.type}-${data.value.username}拨打电话吗？`,
    okText: '拨打',
    cancelText: '取消',
    onOk: () => {
      const params = {
        calleeType: item.value.p_title.calleeType,
        calleeUcUserId: data.value.ucUserId,
        doctorId:
          activeKey.value === 'doctor'
            ? data.value.businessId
            : curOrder.value.doctorInfo.businessId,
        workOrderIds: [curOrder.value.targetWorkOrder.workOrderId]
      }
      callOut(params, {
        userType: item.value.p_title.type,
        name: data.value.username
      })
    }
  })
}
// 岗位职级处理 `doctorTitleId`职级。0医师，1副主任医师，2主任医师，3主治医师，4住院医师',
const doctorTitleText = ['医师', '副主任医师', '主任医师', '主治医师', '住院医师']
const handleLabel = (data, key) => {
  if (key === 'doctorTitleId') {
    return doctorTitleText[`${data[key]}`] || '--'
  } else if (key === 'changeAt') {
    return data[`${key}`] ? moment(data[`${key}`]).format('YYYY-MM-DD HH:mm') + '  更新' : ''
  } else if (key === 'defaultCharge') {
    return data[`${key}`] === 0 ? '免费' : formatAmount(data[`${key}`]) + '元/次'
  } else {
    return data[`${key}`] || '--'
  }
}
const getPopupContainer = trigger => {
  return trigger.parentNode
}
const showPopExcus = item => {
  const { courseServicesFlag, courseServicesCause } = item
  const excusList = [
    '患者待加入全病程服务',
    '患者已加入全病程服务',
    `患者未加入全病程服务:${courseServicesCause}`
  ]
  return excusList[courseServicesFlag]
}
const healthInfo = () => {
  emit('healthInfo')
}
// 查看服务记录
// function goServiceReocrd() {
//   serviceRecordVisible.value = true
//   open.value = false
// }
// 查看更多绑定医生
// function goBindDocList() {
//   bindDocVisible.value = true
//   open.value = false
// }
// 查看复诊日期表
const treatmentRef = ref(null)
function goTreatSheet() {
  open.value = false
  treatmentRef.value.treatmentInit()
}

const editDocTime = () => {
  open.value = false
  Modal.confirm({
    centered: true,
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定为医生修改线下出诊？请与医生沟通确认。`,
    okText: '已确认',
    cancelText: '取消',
    onOk: () => {
      appointSetRef.value.settingInit({ bindUcDoctorId: bindUcDoctorId.value })
    }
  })
}

// 更新协同备注
const handelUpdateRemark = () => {
  getRecommendDoctorDetail()
  if (props.isChatSession) {
    // 如果是当前工单会话，更新当前工单会话的协同备注
    emit('updateRemark')
  }
}
const getRecommendDoctorDetail = () => {
  const params = { ucDoctorId: bindUcDoctorId.value }
  fetchRecommendDoctorDetail(params)
    .then(res => {
      bindInfo.value = res ? res : {}
      const { doctorRemarkVO = {} } = bindInfo.value
      remarkData.value = doctorRemarkVO
      mergeBindInfoData()
    })
    .catch(error => {})
}
const initModal = (detailParams, type) => {
  title.value = '医生'
  const { ucDoctorId, doctorId } = detailParams
  bindUcDoctorId.value = ucDoctorId
  bindDoctorId.value = doctorId
  activeKey.value = type
  bindInfo.value = {}
  doctorRemarkInitParam.value = {
    ucDoctorId,
    doctorId
  }
  getRecommendDoctorDetail()
  open.value = true
}

const doctorConfig = [
  {
    label: '所属医院',
    value: 'hospital'
  },
  {
    label: '岗位职级',
    value: 'title'
  },
  {
    label: '个人简介',
    value: 'introduction'
  },
  {
    label: '个人公告',
    value: 'notice'
  }
]
const assistantConfig = [
  {
    label: '所属部门',
    value: 'deptName'
  }
]
const serviceAttributionRef = ref()
// 打开医生服务归属弹窗
const goServiceAttributionDetail = () => {
  open.value = false
  serviceAttributionRef.value.showModal()
}
defineExpose({
  initModal
})
</script>
<style lang="scss">
.course_tips {
  min-width: 190px;
  text-align: center;
}
</style>
<style scoped lang="scss">
.container {
  ::v-deep(.ant-popover-title) {
    padding: 24px 0;
    margin: 0 24px;
    width: 304px;
  }
  ::v-deep(.ant-popover-inner-content) {
    padding: 0 0 24px 0;
    margin: 0 24px;
    width: 304px;
  }
  .popover-header-box {
    padding-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;
  }
  .popover-header {
    justify-content: flex-start;

    &-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      .auth {
        position: absolute;
        top: 0;
        left: 0;
        width: 46px;
        height: 18px;
        background: #e6e6e6;
        border-radius: 4px 0 8px 0;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        text-align: center;
        &.real {
          color: #ffffff;
          background: #ffa940;
        }
      }
      img {
        width: 100%;
      }
    }
    &-info {
      flex-direction: column;
      justify-content: space-around;
      margin-left: 12px;
      .name {
        font-weight: 500;
        font-size: 16px;
        color: #666666;
        align-items: center;
        line-height: 20px;
        justify-content: flex-start;
        img {
          width: 16px;
          height: 16px;
        }
        div {
          padding-right: 2px;
        }
      }
      .base_info {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }
      .number {
        margin-top: 5px;
        .age {
          display: inline-block;
          margin-left: 24px;
          padding-left: 24px;
          border-left: 1px solid #999999;
        }
      }

      .permission {
        color: red;
      }

      .location {
        color: #999999;
        margin-top: 4px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
      }
    }
  }

  .popover-content {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    .health_service {
      flex-wrap: wrap;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;

      .btn {
        margin: 6px 0;
        padding: 9px 0;
        border-radius: 4px;
        font-size: 14px;
        color: #333333;
        line-height: 14px;
        width: 50%;
        justify-content: center;
        align-items: center;
        &:hover {
          background-color: #f3f4f4;
          cursor: pointer;
        }
        img {
          width: 16px;
          height: 16px;
        }
        span {
          padding: 0 16px 0 8px;
        }
        .right {
          width: 12px;
          height: 12px;
        }
      }
    }
    .box_container {
      overflow-y: scroll;
      max-height: 200px;
    }
    .box {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      &.first_box {
        margin-top: 12px;
      }
      &.last_box {
        margin-bottom: 12px;
      }
      .title {
        color: #999999;
        margin-right: 16px;
        width: 60px;
      }
      .details {
        width: calc(100% - 72px);
        .departName {
          border-right: 1px solid #999999;
          padding-right: 10px;
          margin-right: 6px;
        }
      }
    }
    .announcement_update {
      color: #999999;
    }
    .doctor_price_info {
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
      .info_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        .price_title {
          color: #333333;
        }
        .price_details {
          color: #999999;
          display: flex;
          align-items: center;
        }
        .isOpen {
          color: #24bca2;
        }
        .is_free {
          color: #1890ff;
        }
        .service_attribution {
          min-width: 150px;
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          .right {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    .footer-button {
      margin-top: 12px;
      width: 100%;
      justify-content: space-between;
      .button {
        width: 100%;
        border-radius: 4px;
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
      .callbtn {
        background: #f0f0f0;
        border: none;
      }
    }
    .consultationFee {
      position: relative;
      // display: flex;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      padding: 5px 14px;
      background: #f8f8f8;
      border-radius: 6px;
      overflow: hidden;
      width: 100%;
      // justify-content: space-between;
      margin-top: 10px;
      .price {
        font-weight: 400;
        font-size: 14px;
        color: #ff992b;
      }
    }
    .bind_doc {
      padding-top: 16px;
      .title {
        color: #999999;
        font-weight: 400;
        font-size: 14px;
        .more_data {
          color: #333333;
          cursor: pointer;
          img {
            width: 12px;
            height: 12px;
            margin-left: 8px;
          }
        }
      }
      .doctap {
        background: #f8f8f8;
        border-radius: 8px;
        padding: 12px;
        margin-top: 8px;
        position: relative;
        .course_sign {
          position: absolute;
          top: 0;
          right: 0;
          .flag_str {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            width: 60px;
            height: 20px;
            border-radius: 0 8px 0 8px;
          }
          .flag_join {
            background: #1890ff1a;
            color: #1890ff;
          }
          .flag_ex {
            background: #f0f0f0;
            color: #666666;
          }
        }
        ::v-deep(.ant-empty-normal) {
          margin: 15px 0;
        }
        .info {
          margin-bottom: 9px;
          .name {
            font-size: 14px;
            color: #1a1a1a;
            padding-right: 12px;
          }
          .txt {
            font-size: 12px;
            color: #999999;
          }
          .depart {
            padding-right: 6px;
            margin-right: 6px;
            border-right: 1px solid #999999;
          }
        }
        .hosp {
          margin-bottom: 19px;
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
        .explain {
          .source {
            font-weight: 400;
            font-size: 12px;
            color: #3b3b3b;
          }
          .date {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
    .doc_schedule_container {
      margin-top: 12px;
    }
    .dividingLine {
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
</style>
